<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.39258C10.0716 2.39258 8.18657 2.96441 6.58319 4.03575C4.97982 5.10709 3.73013 6.62983 2.99218 8.41141C2.25422 10.193 2.06114 12.1534 2.43735 14.0447C2.81355 15.936 3.74215 17.6733 5.10571 19.0369C6.46928 20.4004 8.20656 21.329 10.0979 21.7052C11.9892 22.0814 13.9496 21.8884 15.7312 21.1504C17.5127 20.4124 19.0355 19.1628 20.1068 17.5594C21.1782 15.956 21.75 14.0709 21.75 12.1426C21.7473 9.55756 20.7192 7.07919 18.8913 5.2513C17.0634 3.42341 14.585 2.39531 12 2.39258ZM20.25 12.1426C20.2516 13.5802 19.8753 14.9931 19.1588 16.2395L12.75 11.7526V3.92727C14.7987 4.11664 16.703 5.06374 18.0902 6.58322C19.4773 8.10269 20.2475 10.0851 20.25 12.1426ZM11.25 3.92727V11.7526L4.84125 16.2395C4.15523 15.0402 3.78135 13.6879 3.75393 12.3066C3.72652 10.9253 4.04643 9.55923 4.68433 8.33373C5.32223 7.10823 6.25768 6.06256 7.40485 5.29265C8.55202 4.52274 9.87418 4.05325 11.25 3.92727ZM5.70375 17.4666L11.25 13.5835V20.3579C9.09299 20.1609 7.10039 19.1222 5.70375 17.4666ZM12.75 20.3579V13.5835L18.2963 17.4666C16.8996 19.1222 14.907 20.1609 12.75 20.3579Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsPeace'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
